import _ from 'lodash'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { RootState } from '../../stores'
import { fetchCourseFAQListThunk } from '../../stores/courses'

export const useCourseFaqList = (courseId: string) => {
  const dispatch = useDispatch()
  const { isLoading, faqList: courseFAQList } = useSelector((state: RootState) => state.courses)
  useEffect(() => {
    if (!_.isEmpty(courseId)) {
      dispatch(fetchCourseFAQListThunk(courseId))
    }
  }, [courseId, dispatch])

  return { isLoading, courseFAQList }
}
